import { Row, Col, Button } from 'antd';
import DashboardLayout from 'layouts/Dashboard';
import Container from 'components/Container';
import PipeLinePartNumberMapperTable from 'components/table/pipeLinePartNumberMapperTable';
import usePipelineDistributorMapper from './hooks/usePipelineDistributorMapper';
import {
  setCurrentPage,
  setPageSize,
  setFilter,
  setRep,
  reset
} from 'redux/modules/master/pipelinePartnumberMapper/slice';
import { useDispatch, useSelector } from 'react-redux';
import useSave from './hooks/useSave';
import { getPipelinePartNumberMapper } from 'selectors';

import Dropdown from 'components/Dropdown';

export default function PipelinePartNumber() {
  const [
    loading,
    reps,
    partNumberLoading,
    setZipMatch,
    zipMatch,
    mfgPartNumbers,
    distPartNumbers
  ] = usePipelineDistributorMapper();
  const dispatch = useDispatch();
  const { dealDetails, totalCount, rep } = useSelector(
    getPipelinePartNumberMapper
  );
  const handlePagination = (page: number, pageSize?: number) => {
    dispatch(setCurrentPage(page));
    dispatch(setPageSize(pageSize));
  };
  const onFilter = (values: any) => {
    dispatch(setFilter(values));
  };

  const repField = (
    <Dropdown
      onChange={(value: any) => dispatch(setRep(value))}
      dataSource={reps}
      valueKey=""
      value={rep}
      defaultValue={reps[0]}
      placeholder="Reps"
      style={{ width: 180 }}
    />
  );

  return (
    <DashboardLayout
      title="Pipeline Part Number Mapper"
      extra={[
        <Button block type="primary" key="0">
          Pull Latest Deals
        </Button>
      ]}
      path={['Home', 'Master', 'Pipeline Part Number Mapper']}
    >
      <Row style={{ margin: '0px', width: '100%' }} align="middle">
        <Container>
          <PipeLinePartNumberMapperTable
            mfgPartNo={mfgPartNumbers}
            onSave={useSave}
            distPartNumbers={distPartNumbers}
            data={dealDetails}
            totalCount={totalCount}
            handlePagination={handlePagination}
            loading={loading || partNumberLoading}
            onFilter={onFilter}
            repField={repField}
            setZipMatch={setZipMatch}
            zipMatch={zipMatch}
          />
        </Container>
      </Row>
    </DashboardLayout>
  );
}
